import React,{useEffect,useRef} from "react";
import {Box,Typography} from "@mui/material";
import "./roadmap.css";
import {setupRoadmapAnimations} from "../animations/roadmapsAnimation";
import colors from "../../../../theme/colors";
import typography from "../../../../theme/typography";

const roadmapItems=[
  {
    quarter:"Q1 2025",
    title:"Platform Launch",
    points:[
      "Core Lottery System",
      "Smart Contract Integration",
      "Initial Game Suite"
    ]
  },
  {
    quarter:"Q2 2025",
    title:"Game Expansion",
    points:[
      "New Game Experiences",
      "Additional Betting Options",
      "Mobile Optimization"
    ]
  },
  {
    quarter:"Q3 2025",
    title:"Ecosystem Growth",
    points:[
      "Token Utilities",
      "Community Features",
      "Global Expansion"
    ]
  },
  {
    quarter:"Q4 2025",
    title:"Community & Beyond",
    points:[
      "Community Governance",
      "More Games",
      "Strategic Partnerships"
    ]
  }
];

const Roadmap=()=>{
  const sectionRef=useRef(null);
  const stageRef=useRef(null);
  const trackRef=useRef(null);
  const itemRefs=useRef([]);
  const centerRef=useRef(null);

  useEffect(()=>{
    return setupRoadmapAnimations({
      sectionRef,
      stageRef,
      trackRef,
      itemRefs,
      centerRef,
      roadmapItems
    });
  },[]);

  return(
    <Box
      ref={sectionRef}
      component="section"
      className="roadmap-section"
    >
      <Box className="roadmap-header">
        <Typography className="roadmap-eyebrow" sx={{ color: colors.slate[500], fontFamily: typography.fontFamily }}>
          ROADMAP
        </Typography>

        <Typography className="roadmap-heading" sx={{ color: colors.home.navyDeep, fontFamily: typography.h2.fontFamily }}>
          Our Journey Forward
        </Typography>

        <Typography className="roadmap-description" sx={{ color: colors.text.secondary, fontFamily: typography.fontFamily }}>
          Follow the key milestones shaping the future of AutoBET
          as we build a transparent and engaging gaming ecosystem.
        </Typography>
      </Box>

      <Box
        ref={stageRef}
        className="roadmap-stage"
      >
        <Box
          ref={centerRef}
          className="roadmap-center-marker"
        >
          <Box className="roadmap-center-dot"/>
        </Box>

        <Box
          ref={trackRef}
          className="roadmap-track"
        >
          <Box className="roadmap-line"/>

          {roadmapItems.map((item,index)=>(
            <Box
              key={item.quarter}
              ref={element=>{
                itemRefs.current[index]=element;
              }}
              className={`roadmap-item roadmap-item-${index}`}
            >
              <Box className="roadmap-bullet">
                <Box className="roadmap-bullet-inner"/>
              </Box>

              <Box className="roadmap-card">
                <Typography className="roadmap-quarter" sx={{ color: colors.slate[500], fontFamily: typography.fontFamily }}>
                  {item.quarter}
                </Typography>

                <Typography className="roadmap-title" sx={{ color: colors.home.navyDeep, fontFamily: typography.h3.fontFamily }}>
                  {item.title}
                </Typography>

                <Box className="roadmap-points">
                  {item.points.map(point=>(
                    <Box
                      key={point}
                      className="roadmap-point"
                    >
                      <Box className="roadmap-check">
                        ✓
                      </Box>

                      <Typography className="roadmap-point-text" sx={{ color: colors.text.secondary, fontFamily: typography.fontFamily }}>
                        {point}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

    </Box>
  );
};

export default Roadmap;